<script>
    import {onMount} from 'svelte';

    import store from '../../Stores/usuario-edicion-store';
    import {validaUsuario} from '../../Modelos/Usuario';

    import {url, goto} from '@sveltech/routify';

    import Loading from "../../Components/UI/Loading.svelte";
    import Error from "../../Components/UI/Error.svelte";
    import Titulo from "../../Components/UI/Titulo.svelte";
    import Migas from "../../Components/UI/Migas/Migas.svelte";
    import Miga from "../../Components/UI/Migas/Miga.svelte";
    import Formulario from "../../Components/Usuarios/Edicion/Formulario.svelte";

    onMount(() => store.nuevo());

    let usuario, error, errores;
    $: usuario = $store.usuario;
    $: errores = validaUsuario(usuario);
    $: error = $store.error;
</script>

<style>
    h2 .material-icons {
        font-size: 2.5em;
        vertical-align: bottom;
        line-height: 1;
    }

    @media (min-width: 1024px) {
        .fila {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: var(--padding-global);
        }

        .fila-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-gap: var(--padding-global);
        }
    }
</style>

<svelte:head>
    <title>Nuevo usuario</title>
</svelte:head>

<Migas>
    <Miga url={$url('/usuarios')}>Usuarios</Miga>
    <Miga actual>Nuevo usuario</Miga>
</Migas>

<Titulo>Nuevo usuario</Titulo>

{#if $store.cargando}
    <Loading/>
{:else if error}
    <Error mensaje={error} on:cancel={() => error = null}/>
{:else if usuario}
    <Formulario on:enviado={() => $goto('/usuarios')}/>
{/if}